import { useNavigate, useParams } from "react-router-dom";
import MedicalRecordsSection from "../components/medical-records/medical-records-section";
import VitalSummaryCard from "../components/vitals/vital-summary-card";
import ThemedSpinner from "../components/shared/spinner";
import Typography from "../components/shared/typography";
import { useSetPageContext } from "../hooks/PageContext";
import useLoadVitals from "../hooks/useLoadVitals";
import { buildRecordDetailPath } from "#/lib/medicalRecords";

const VitalsPage = () => {
  const { userId } = useParams<{ userId?: string }>();
  const navigate = useNavigate();
  const { vitals, isLoading, error } = useLoadVitals(userId);
  useSetPageContext(vitals);

  if (isLoading) {
    return (
      <div className="container mx-auto px-4 py-8">
        <ThemedSpinner />
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mx-auto px-4 py-8">
        <Typography variant="h4" className="text-terracotta-500">
          Failed to load vitals
        </Typography>
      </div>
    );
  }

  const hasVitals = vitals.length > 0;

  return (
    <MedicalRecordsSection
      title="Vital Signs"
      buttonLabel="Add Vital Signs"
      uploadMessage={`Add vital signs to this user's medical records ${
        userId ?? ""
      }`}
      hasRecords={hasVitals}
      emptyTitle="No vital signs listed."
    >
      {hasVitals
        ? vitals.map((v) => (
            <div
              key={v.id}
              id={`record-vital-${v.id}`}
              className="file-record-anchor block scroll-mt-24"
            >
              <VitalSummaryCard
                vital={v}
                onClick={() => {
                  const detailPath = buildRecordDetailPath(
                    "vitals",
                    v.id,
                    userId
                  );
                  if (!detailPath) return;
                  navigate(detailPath, { state: { record: v } });
                }}
              />
            </div>
          ))
        : null}
    </MedicalRecordsSection>
  );
};

export default VitalsPage;
